import React, { useEffect, useState } from 'react'
// import FavPages from './FavPages'
// import Search from './Search'
// import IssuesHistory from './IssuesHistory'
// import ProjectManagement from './ProjectManagement'
import { connect } from 'react-redux'
import { Button } from 'antd'
import Text from 'components/customComponents/Text'
import { updateNotificationItem } from 'redux/notifications/actions'
import Modal from 'components/customComponents/Modal'

import BookaMeeting from 'pages/bookAmeeting'
// import TimeZone from './TimeZoneSelector'
// import Notifications from './Notifications'
import UserMenu from './UserMenu'

import style from './style.module.scss'

const mapStateToProps = ({ dispatch, user, general, register }) => ({
  dispatch,
  clientName: general.client.registeredCompanyName,
  ws: user.ws,
  bookaMeetingModal: register.bookaMeetingModal,
  overAllRiskCategory: register.overAllRiskCategory,
})

const TopBar = ({ dispatch, ws, bookaMeetingModal, overAllRiskCategory }) => {
  const [hubspotUrlBasedOnRisk] = useState(
    overAllRiskCategory !== undefined &&
      (overAllRiskCategory === 'high_risk_two' || overAllRiskCategory === 'high_risk_three')
      ? 'https://lp.payconstruct.com/meetings/matt-mason/meet-with-onboarding'
      : 'https://lp.payconstruct.com/meetings/matt-mason/inquiry-call-with-the-team',
  )

  useEffect(() => {
    if (ws) {
      ws.onopen = () => {
        console.log('connected')
      }
      ws.onmessage = evt => {
        dispatch(updateNotificationItem(JSON.parse(evt.data)))
      }
      ws.onclose = () => {
        console.log('disconnected')
      }
    }
  }, [dispatch, ws])

  const handleBookaMeeting = () => {
    dispatch({
      type: 'OPEN_MODAL_BOOK_A_MEETING',
      payload: true,
      bookMeetingUrl: hubspotUrlBasedOnRisk,
    })
  }
  const handleCloseModal = () => {
    dispatch({
      type: 'OPEN_MODAL_BOOK_A_MEETING',
      payload: false,
    })
  }

  return (
    <div className={style.topbar}>
      <Modal
        modalView={bookaMeetingModal}
        modalType="BOOK A MEETING"
        modalWidth={905}
        modalDescription={<BookaMeeting />}
        handleClosePopup={handleCloseModal}
      />
      <div className="mr-4">
        {/* <FavPages /> */}
        <span className="fe fe-layers" style={{ color: '#fff', fontSize: '12px' }}>
          {' '}
        </span>
        <Text weight="bold" size="small" style={{ color: '#fff' }}>
          Account Activation
        </Text>
      </div>
      <div className="mr-auto">{/* <Search /> */}</div>
      <div className="mr-4 d-none d-md-block">{/* <IssuesHistory /> */}</div>
      <div className="mb-0 mr-4 d-xl-block d-none">
        {/* <ProjectManagement /> */}
        <Button
          size="small"
          shape="round"
          style={{ background: '#fff', border: '1px solid #fff', color: 'black', fontSize: '12px' }}
          onClick={handleBookaMeeting}
        >
          Book a meeting
        </Button>
      </div>
      {/* <div className="mr-4 d-none d-sm-block">
        <TimeZone />
      </div>
      <div className="mr-4 d-none d-sm-block">
        <Notifications />
      </div> */}
      <div className="">
        <UserMenu />
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(TopBar)
